import AdminLayout from "@/layout/AdminLayout/adminLayout";
import AdminAuthLayout from "@/layout/AdminLayout/adminAuthLayout";
import AdminLogin from "@/pages/Admin/Authentication/adminLogin";
import BulkOrders from "@/pages/Admin/OrdersManagement/BulkOrders";
import CateringEvent from "@/pages/Admin/OrdersManagement/CateringEvent";
import Dashboard from "@/pages/Admin/Dashboard";
import ArchivedOrders from "@/pages/Admin/OrdersManagement/ArchivedOrders";
import CompanySetup from "@/pages/Admin/CompanyManagement/Setup";
import Staff from "@/pages/Admin/CompanyManagement/Staff";
import Revenue from "@/pages/Admin/CompanyManagement/Revenue";
import OrderOperations from "@/pages/Admin/CompanyManagement/Operations";
import CustomersManager from "@/pages/Admin/Customers";
import CategoryPage from "@/pages/Admin/ProductManagement/Category";
import BulkPurchaseProducts from "@/pages/Admin/ProductManagement/BulkPurchase";
import EventCateringPage from "@/pages/Admin/ProductManagement/Event";
import InventoryControlPage from "@/pages/Admin/ProductManagement/InventoryControl";
import TransactionManager from "@/pages/Admin/Transaction";
import Promotions from "@/pages/Admin/Promos&Discounts";
import FeedbackRatings from "@/pages/Admin/CustomerExperience/FeedbackRatings";
import TermsConditions from "@/pages/Admin/CustomerExperience/TermsConditions";
import { ProtectedRoute, PermissionRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoutes";

import Notfound from "@/pages/NotFound/Notfound";
import DefaultRedirect from "./DefaultRedirect";
import Analytics from "@/pages/Admin/Analytics";
import AdminChangePassword from "@/pages/Admin/Authentication/changePassword";
import UserProfile from "@/pages/Admin/UserProfile";

/**
 * Admin Routes with Permission-based Protection
 * Structure:
 *
 * - PublicRoute: Login page (redirects to admin if logged in)
 * - ProtectedRoute: Auth check (redirects to login if not authenticated)
 * - PermissionRoute: Permission check (redirects to default route if no access)
 */
const adminRoutes = [
  // Auth routes - public
  {
    path: "/admin-auth",
    element: <PublicRoute />,
    children: [
      {
        element: <AdminAuthLayout />,
        children: [{ index: true, element: <AdminLogin /> }],
      },
    ],
  },
  {
    path: "/admin/change-password/:token",
    children: [{ index: true, element: <AdminChangePassword /> }],
  },

  // Protected admin routes
  {
    path: "/admin",
    element: <ProtectedRoute redirectPath="/admin-auth" />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          // Default redirect based on permissions
          { index: true, element: <DefaultRedirect /> },

          // Unauthorized page
          { path: "notfound", element: <Notfound /> },
          //Analytics page
          { path: "analytics", element: <Analytics /> },
          // Admin user profile page
          { path: "profile", element: <UserProfile /> },
          // MAIN - Standalone
          {
            path: "dashboard",
            element: <PermissionRoute permissionName="dashboard" />,
            children: [{ index: true, element: <Dashboard /> }],
          },
          {
            path: "transactions",
            element: <PermissionRoute permissionName="transactions" />,
            children: [{ index: true, element: <TransactionManager /> }],
          },
          {
            path: "customers",
            element: <PermissionRoute permissionName="customers" />,
            children: [{ index: true, element: <CustomersManager /> }],
          },

          // MAIN - Orders & Bookings
          {
            path: "bulk-orders",
            element: <PermissionRoute permissionName="bulk orders" />,
            children: [{ index: true, element: <BulkOrders /> }],
          },
          {
            path: "catering-orders",
            element: <PermissionRoute permissionName="catering orders" />,
            children: [{ index: true, element: <CateringEvent /> }],
          },
          {
            path: "archived-orders",
            element: <PermissionRoute permissionName="archived orders" />,
            children: [{ index: true, element: <ArchivedOrders /> }],
          },

          // MANAGEMENT - Company Management
          {
            path: "company-setup",
            element: <PermissionRoute permissionName="company setup" />,
            children: [{ index: true, element: <CompanySetup /> }],
          },
          {
            path: "staff",
            element: <PermissionRoute permissionName="staff" />,
            children: [{ index: true, element: <Staff /> }],
          },
          {
            path: "revenue",
            element: <PermissionRoute permissionName="revenue" />,
            children: [{ index: true, element: <Revenue /> }],
          },
          {
            path: "operations",
            element: <PermissionRoute permissionName="order and operations" />,
            children: [{ index: true, element: <OrderOperations /> }],
          },

          // MANAGEMENT - Product Management
          {
            path: "categories",
            element: <PermissionRoute permissionName="category" />,
            children: [{ index: true, element: <CategoryPage /> }],
          },
          {
            path: "bulk-purchases",
            element: <PermissionRoute permissionName="bulk purchase" />,
            children: [{ index: true, element: <BulkPurchaseProducts /> }],
          },
          {
            path: "catering",
            element: <PermissionRoute permissionName="catering" />,
            children: [{ index: true, element: <EventCateringPage /> }],
          },
          {
            path: "inventory-control",
            element: <PermissionRoute permissionName="inventory control" />,
            children: [{ index: true, element: <InventoryControlPage /> }],
          },

          // MANAGEMENT - Customer Experience
          {
            path: "promotions",
            element: <PermissionRoute permissionName="promos and discounts" />,
            children: [{ index: true, element: <Promotions /> }],
          },
          {
            path: "feedback",
            element: <PermissionRoute permissionName="feedback and ratings" />,
            children: [{ index: true, element: <FeedbackRatings /> }],
          },
          {
            path: "terms&conditions",
            element: <PermissionRoute permissionName="terms and conditions" />,
            children: [{ index: true, element: <TermsConditions /> }],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Notfound />,
  },
];

export default adminRoutes;
